import React from 'react';
import PublicChrome from './public/PublicChrome';
import BrandKitDisplay from './BrandKitDisplay';
import SeoHead, { breadcrumbJsonLd } from './seo/SeoHead';

const BrandKitPage: React.FC = () => (
  <PublicChrome>
    <SeoHead
      title="Brand Kit"
      description="Official DUSKPROOF logos, palette, and typography for press and partners."
      path="/brand-kit"
      jsonLd={breadcrumbJsonLd([
        { name: 'Home', path: '/' },
        { name: 'Brand Kit', path: '/brand-kit' },
      ])}
    />
    <BrandKitDisplay />
  </PublicChrome>
);

export default BrandKitPage;
